import { POPUPS } from "@common/constants/popups";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";

import { getPopupDispatchers } from "../contexts/popup";

export function updateFromCSharp(params, bool) {
  const { openPopup } = getPopupDispatchers();
  const { token } = JSON.parse(sessionStorage.getItem('authData'));
  const data = JSON.parse(params);
  let textCode;

  if (bool) {
    swarmRequest({
      token,
      user_info: {
        Id: data.Id,
        FirstName: data.Name,
        LastName: data.Surname,
        Email: data.Email,
        DocNumber: data.CNP,
        MobileNumber: data.Phone,
        Rfid: data.CardId,
        CurrencyId: 'RON',
        BTag: data.BTag,
        RegionId: 189,
      },
    }, 'terminal_update_player')
      .then((response) => {
        textCode = response.text_code;
        if (response.text_code === '0') {
          openPopup(POPUPS.SET_PIN_CODE, { rfid: data.CardId });
        } else {
          openPopup(POPUPS.FAIL_POPUP, { textCode });
        }
      })
      .catch((error) => console.warn(error));
  }
}
